import FlightSearchInput from './flightSearchInput';

export default class FlightSearch {
  flightSearchInputs: FlightSearchInput[];
  saleChannelId: string;
}
